const usePeopleBusiness = ({ businessIdentityData }) => {
  const directors = businessIdentityData?.directors;
  const officers = businessIdentityData?.officers;
  const shareholders = businessIdentityData?.shareHolders;
  const registeredAgents = businessIdentityData?.registeredAgents;

  return {
    directors,
    officers,
    shareholders,
    registeredAgents,
  };
};

export default usePeopleBusiness;
